import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';

const AddMember = () => {
    const bookState = useBookStore();
    const book = bookState.book;
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const navigate = useNavigate();
    // const {token} = useAuth();

    useEffect(() => {
        if(book.id === undefined){
            navigate('/',{replace:true})
        }
    }, []);

    const addMember = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/member/add', {
                book_id: book.id,
                email: email
            });
            console.log(response.data)
            navigate("/members")
        } catch (error) {
            if (error.response) {
                console.log(error.response)
                //setMsg(error.response.data.);
            }
        }
    }

    return (
        <div>
            <Topbar
                title={'Tambah Member'}
                back={()=>navigate('/members')}
            />
            <div className="container p-5">
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <p className='is-size-6 mb-4 ml-4'>Buku Kas : {book.title}</p>


                        <form onSubmit={addMember} className="card">
                            <div className='card-content'>
                                <p className="has-text-centered">{msg}</p>
                                <p>Pastikan alamat email yang akan diundang sudah terdaftar di dalam aplikasi buku kas.</p>
                                <div className="field mt-5">
                                    <label className="label">Email</label>
                                    <div className="controls">
                                        <input type="email" className="input" placeholder='email'
                                            value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <footer className="card-footer  has-text-white has-background-primary-30">
                                <button className="card-footer-item has-text-weight-bold ">Simpan</button>
                            </footer>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddMember
